import React from 'react';

export const DomainsTitle = ({ record }) => {
  return <span>Domain {record ? `"${record.displayedDomain}"` : ''}</span>;
};
